import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ControlInterface } from 'edocatbase/Form';
import { ReduxComponentInterface } from 'edocatbase/Global';
import { Dispatch } from 'redux';
import { addNewContact } from '../../../actions/form';
import { onFormChange } from '../../../actions/form';
import { toggleModal } from '../../../../ModalTest/actions';
import Modal from '../../../../ModalTest';
import EdocatTextField from '../../../../TextField';
import Button from '../../../../Button';

interface NewContactModalProps extends ControlInterface, ReduxComponentInterface {
	formInstanceId: string;
	params: any;
	view: boolean;
	index: number;
	items: any;
	newContactModal: any;
}

interface NewContactModalState {
	name: string;
	phone: string;
	email: string;
	note: string;
}

class NewContactModal extends React.PureComponent<NewContactModalProps, NewContactModalState> {
	constructor(props: NewContactModalProps) {
		super(props);
		this.state = {
			name: '',
			phone: '',
			email: '',
			note: '',
		};
	}
	componentDidMount(): void {
		if(this.props.newContactModal?.items?.edit && this.props.newContactModal?.items?.rowValue){
			this.setState(this.props.newContactModal.items.rowValue);
		}
	}
	onClose = (event?: React.MouseEvent) => {
		event && event.preventDefault();
		const { actions, formInstanceId } = this.props;
		actions.toggleModal(false, 'newContactModal', null, formInstanceId);
	};

	handleChange = (event: React.ChangeEvent, name: NewContactModalState | string) => {
		const { value } = event.target as HTMLInputElement;
		this.setState({ [name]: value });
	};

	handleSubmit = () => {
		const { actions, index, formInstanceId, name } = this.props;
		const value = this.state;
		if(this.props.newContactModal?.items?.edit){
			let finalValue = JSON.parse(JSON.stringify(this.props.newContactModal.items.value));
			finalValue[index].contacts[this.props.newContactModal.items.rowIndex] = value;
			actions.onFormChange(formInstanceId, [name], finalValue);
		} else {
			actions.addNewContact(formInstanceId, index, value, name);
		}
		this.onClose();
	};

	render() {
		const { formInstanceId } = this.props;

		return (
			<Modal
				className={'new-contacts-modal'}
				hideActionButtons
				onClose={this.onClose}
				name={'newContactModal'}
				reducerPath={[formInstanceId, 'formModal']}
				title={window.Alfresco.messages.global['edocat.forms.contacts']}
			>
				<div className="modal-body">
					<div className="form-row">
						<EdocatTextField
							label={window.Alfresco.messages.global['label.companyname']}
							onChange={(event: React.ChangeEvent) => this.handleChange(event, 'name')}
							value={this.state.name}
						/>
					</div>
					<div className="form-row">
						<EdocatTextField
							label={window.Alfresco.messages.global['label.companytelephone']}
							onChange={(event: React.ChangeEvent) => this.handleChange(event, 'phone')}
							value={this.state.phone}
						/>
					</div>
					<div className="form-row">
						<EdocatTextField
							label={window.Alfresco.messages.global['button.view.email']}
							onChange={(event: React.ChangeEvent) => this.handleChange(event, 'email')}
							value={this.state.email}
						/>
					</div>
					<div className="form-row">
						<EdocatTextField
							label={'Poznámka'}
							onChange={(event: React.ChangeEvent) => this.handleChange(event, 'note')}
							value={this.state.note}
						/>
					</div>
				</div>
				<div className="modal-actions">
					<Button primary label={window.Alfresco.messages.global['button.save']} onClick={this.handleSubmit} />
					<Button label={window.Alfresco.messages.global['button.close']} onClick={this.onClose} />
				</div>
			</Modal>
		);
	}
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
	actions: bindActionCreators({ toggleModal, addNewContact, onFormChange }, dispatch),
});

export default connect(null, mapDispatchToProps)(NewContactModal);
